<template>
  <div class="kahiSummary">
    <router-link
      v-bind:to="{ name: 'KahiDetail', params: { detailId: kahi.KID } }"
    >
      <div class="kahiSummaryPhoto">
        <kahi-photo
          v-bind:image="kahi.image"
          v-bind:image-load="imageLoad"
          v-bind:spinner-size="'5px'"
        ></kahi-photo>
      </div>
      <div class="kahiSummaryBody">
        <kahi-meta-info
          v-bind:display-type="'list'"
          v-bind:saku="kahi.saku1"
          v-bind:volume="kahi.volume"
          v-bind:kno="kahi.kno1"
        ></kahi-meta-info>
        <div
          class="kahiSummaryBodyUta"
          v-html="breakLineUta(kahi.uta1, 2, null)"
        ></div>
        <div class="kahiSummaryBodyDistance">
          現在地から{{ convertDistance(kahi.distance) }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script lang="ts" src="./KahiSummary.ts"></script>
<style scoped lang="scss" src="./KahiSummary.scss"></style>
